export const NOTIFICATION_STATE_KEY = 'aumicoNotification';
export const REQUEST_LOADING_INDICATOR_STATE_KEY = 'aumicoRequestLoadingIndicator';
export const CORE_FEATURE_KEY = 'aumicoCoreMicroservice';
export const CONFIGURATIONS_FEATURE_KEY = 'aumicoConfigurations';
export const SURVEYS_FEATURE_KEY = 'aumicoSurveys';
export const ANNOUNCEMENTS_FEATURE_KEY = 'aumicoAnnouncements';
export const USER_NOTIFICATIONS_FEATURE_KEY = 'aumicoUserNotifications';

// Shouldn't be exported or be added to index.ts of the library
